module.exports = __webpack_public_path__ + "static/media/icon-stop.1268f3e1.svg";